import { render, staticRenderFns } from "./VideoStreamPlayer.vue?vue&type=template&id=893b3178&"
import script from "./VideoStreamPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoStreamPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports